/**
 * Idle warm-up for the modal experience.
 *
 * Popup bodies are per-type chunks (see modalLoaders.ts). CommonModalsLazy
 * fetches the thin host at idle / CTA intent. Warm high-traffic bodies + OTP
 * step chunks here so common opens and post-submit OTP never pop in late.
 */

import { warmHotModalChunks } from "./modalLoaders";

type ChunkLoader = () => Promise<unknown>;

const otpStepChunkLoaders: ChunkLoader[] = [
  () => import("@molecules/Forms/VerifyOTPForm"),
  () => import("@/components/atoms/Loader/Loader"),
  () =>
    import(
      "@/components/molecules/LeadAPIFailedErrorMsg.tsx/LeadAPIFailedErrorMsg"
    ),
];

let scheduled = false;

/** Warm post-open chunks during browser idle (skipped under Data Saver). */
export function preloadAllModalChunks(): void {
  if (scheduled || typeof window === "undefined") return;
  if ((navigator as any)?.connection?.saveData) return;
  scheduled = true;

  const schedule =
    typeof window.requestIdleCallback === "function"
      ? (cb: () => void) => window.requestIdleCallback(cb, { timeout: 800 })
      : (cb: () => void) => window.setTimeout(cb, 200);

  schedule(() => {
    warmHotModalChunks();
    otpStepChunkLoaders.forEach((load) => void load().catch(() => {}));
  });
}
